import React, {Component} from 'react'
import styled, { keyframes } from 'styled-components'
import fire from '../database/firebase'
import {Nav, Navbar, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'
import { fadeInLeft } from 'react-animations';
import { fadeInRight } from 'react-animations';
import { fadeInUpBig } from 'react-animations';

const fadeInLeftAnimation = keyframes`${fadeInLeft}`;
const FadeInLeftDiv = styled.div `
    animation: 2.5s ${fadeInLeftAnimation};
`
const FadeInLeftDiv2 = styled.div `
    animation: 4.5s ${fadeInLeftAnimation};
`

const fadeInRightAnimation = keyframes`${fadeInRight}`;
const FadeInRightDiv = styled.div `
    animation: 3.5s ${fadeInRightAnimation};
`

const fadeInUpAnimation = keyframes`${fadeInUpBig}`;
const FadeInUpDiv = styled.div `
    animation: 2.5s ${fadeInUpAnimation};
`
const FadeInUpDiv2 = styled.div `
    animation: 3.5s ${fadeInUpAnimation};
`
const FadeInUpDiv3 = styled.div `
    animation: 4.5s ${fadeInUpAnimation};
`


const Styles = styled.div `

// - - NAVBAR - - //

.theNavbar {
    max-width: 95%;
}

.logo {
    font-family: Val;
    color: #99CC63;
    font-size: 30px;
    margin-left: 2%;
    cursor: pointer;
}

.logo:hover {
    color: #724E39;
}

.linkItem {
    max-width: 100%;
    margin-right: 15%;
}

    // - - NAVBAR LINKS - - //

.navLinks {
    margin-right: 15%;
    font-size: 20px;
    font-family: DM Sans;
}

.linkItem {
    margin-right: 50%;
}

.linkItem label {
    color: #99CC63;
    cursor: pointer;
}

.linkItem label:hover {
    color: #724E39;
}

    // - - HEADER - - //

.header {
    text-align: center;
    // height: 90vh;
}

.header:after {
    content: "";
    display:table;
    clear: both;
}

.brandInfo {
    width: 50%;
    text-align: center;
    float: left;
}

.brandInfo h1 {
    font-family: Val;
    color: #99CC63;
}   

.brandInfo h5 {
    color: #724E39;
    text-align: justify;
    font-family: DM Sans;
}

.brandInfo video {
    width: 85%;
}

.info {
    width: 50%;
    text-align: center;
    float: left;
}

.info video {
    width: 85%;
}

.info h1 {
    // margin-top: 10%;
    font-family: Val;
    color: #99CC63;
}

.info h5 {
    font-family: DM Sans;
    color: #724E39;
    text-align: justify;
    margin-right: 5%;
    margin-top: 3%;
}

.areas {
    text-align: center;
    border: 0px solid black;
    margin-left: 0%;
    margin-right: 55%;
    border-radius: 8px;
    margin-bottom: 2%;
    margin-top: 2%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.areas h4 {
    font-family: DM Sans;
    color: #99CC63;
    font-wieght: bold;
    padding-top: 3%;
    margin-bottom: 0px;
    // padding-bottom: 5%;
}

.areas p {
    color: #724E39;
    font-family: DM Sans;
    padding-bottom: 2.5%;
}

    // - - AUDIENCE - - //

.audience {
    text-align: center;
    margin-bottom: 4%;
}

.audience h1 {
    font-family: Libre Franklin Black;
    color: #724E39;
}

.audience h2 {
    color: #724E39;
    font-family: DM Sans;
    font-weight: bold;
}

.audienceList {
    text-align: center;
    margin-left: 12.5%;
    margin-right: 12.5%;
    margin-top: 3%;
}

.audienceList:after {
    content: "";
    display:table;
    clear: both;
}

.audienceLeft {
    width: 10%;
    text-align: center;
    float: left;
}

.audienceRight {
    width: 90%;
    text-align: center;
    float: left;
}


.audienceList h1 {
    margin-bottom: 5%;
    color: #64A61F;
    text-align: justify;
    font-size: 45px;
}


    // - - GET STARTED BUTTON - - //

.getStartedBtn {
    margin-bottom: 2.75%;
}

.getStartedBtn button {
    padding: 1.5%;
    color: #724E39;
    background-color: #99CC63;
    width: 15%;
    font-family: DM Sans;
    font-size: 19px;
    border: 2px solid transparent;
    border-radius: 9px;
    font-weight: bold;
    margin-top: 3%;
}

.getStartedBtn p {
    font-family: DM Sans;
    color: #724E39;
    margin-top: 1%;
}

    // - - DEMOS - - //

.demo1:after {
    content: "";
    display:table;
    clear: both;
}

.demo1Col1 {
    width: 50%;
    text-align: center;
    float: left;
    // margin-top: 4%;
    background-color: #99CC63;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.demo1Col2 {
    width: 50%;
    text-align: center;
    float: left;
}

.demo1Col1 video {
    width: 85%;
}

.demo1Col2 img {
    width: 40%;
}

.demo1Col2 h4 {
    margin-top: 3%;
    font-family: Libre Franklin Black;
    font-weight: bold;
    color: #7BB83B;
}

.demo1Col2 p {
    text-align: justify;
    margin-left: 4.5%;
    margin-right: 4.5%;
    font-family: DM Sans;
    color: #724E39;
    font-weight: bold;
}

.demo1Col2 label {
    color: black;
    margin-left: 1%;
}

    // - - DEMO 2 - - //

.demo2:after {
    content: "";
    display:table;
    clear: both;
}

.demo2Col1 {
    width: 50%;
    text-align: center;
    float: left;
}

.demo2Col2 {
    width: 50%;
    text-align: center;
    float: left;
    margin-top: 2%;
    background-color: #99CC63;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

.demo2Col2 video {
    width: 85%;
}

.demo2Col2 img {
    width: 85%;
}

.demo2Col1 img {
    width: 40%;
    margin-top: 7.5%;
}

.demo2Col1 h4 {
    margin-top: 3%;
    font-family: Libre Franklin Black;
    font-weight: bold;
    color: #7BB83B;
}

.demo2Col1 p {
    text-align: justify;
    margin-left: 4.5%;
    margin-right: 4.5%;
    font-family: DM Sans;
    color: #724E39;
    font-weight: bold;
}

.demo2Col1 label {
    color: black;
    margin-left: 1%;
}

    // - - DEMO 3 - - //

.demo3:after {
    content: "";
    display:table;
    clear: both;
}

.demo3Col1 {
    width: 50%;
    text-align: center;
    float: left;
    margin-top: 2%;
    background-color: #99CC63;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}

.demo3Col2 {
    width: 50%;
    text-align: center;
    float: left;
}

.demo3Col1 video {
    width: 85%;
}

.demo3Col2 img {
    width: 40%;
    margin-top: 5%;
}

.demo3Col2 h4 {
    margin-top: 3%;
    font-family: Libre Franklin Black;
    font-weight: bold;
    color: #7BB83B;
}

.demo3Col2 p {
    text-align: justify;
    margin-left: 4.5%;
    margin-right: 4.5%;
    font-family: DM Sans;
    color: #724E39;
    font-weight: bold;
}

.demo3Col2 label {
    color: black;
    margin-left: 1%;
}

.landingText {
    background-color: #F5DE89;
    border-radius: 8px;
    margin-left: 3%;
    margin-right: 3%;
    padding-top: 2%;
    padding-bottom: 2%;
}

    // - - FOOTER - - //


.footer:after {
    content: "";
    display:table;
    clear: both;
}

.footer {
    margin-top: 3%;
    height: 30vh;
    background-color: #F5DE89;
}

.footerCol {
    width: 33.3%;
    text-align: center;
    float: left;
}

.footerCol img {
    margin-top: 5%;
    width: 20%;
}

.footerCol h5 {
    margin-top: 12%;
    color: #724E39;
    font-family: DM Sans;
    font-size: 21px;
    font-weight: bold;
    cursor: pointer;
}

.footerCol p {
    margin-top: 35%;
    font-family: DM Sans;
    color: #724E39;
    font-size: 17.5px;
}


// - - - - - - - - - - - PHONE/TABLET DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 800px) {

        // - - NAVBAR LINKS - - //

    .linkItem label {
        margin-left: 5%;
    }

        // - - HEADER - - //

    .brandInfo {
        width: 100%;
        margin-bottom: 10%;
    }
    
    // .logo video {
    //     width: 100%;
    // }
    
    .info {
        width: 100%;
    }

    .info h5 {
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

        // - - CARDS - - /

    .areas {
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

        // - - GET STARTED BUTTON - - //

    .getStartedBtn {
        margin-bottom: 9.5%;
    }
    
    .getStartedBtn button {
        padding: 3%;
        width: 45%;
    }

        // - - AUDIENCE - - //

    .audience h1 {
        font-size: 25px;
        margin-left: 2%;
        margin-right: 2%;
    }

    .audience h2 {
        font-size: 21px;
    }

    .audienceList {
        margin-left: 10.5%;
        margin-right: 10.5%;
    }

    .audienceList h1 {
        font-size: 20px;
        hyphens: auto;
        margin-bottom: 12%;
    }

        // - - DEMOS - - //

    .demo1Col1 {
        width: 92.5%;
        background-color: #8FC458;
    }

    .demo1Col2 {
        width: 100%;
        margin-top: 10%;
    }

    .demo1Col2 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

        // - - DEMO 2 - - //

    .demo2Col1 {
        width: 100%;
    }

    .demo2Col1 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

    .demo2Col2 {
        width: 92.5%;
        float: right;
        background-color: #8FC458;
    }

        // - - DEMO 3 - - //

    .demo3Col1 {
        width: 92.5%;
        margin-top: 15%;
        background-color: #8FC458;
    }

    .demo3Col2 {
        width: 100%;
    }

    .demo3Col2 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

        // - - FOOTER- - //

    .footer {
        margin-top: 6.5%;
        height: 100%;
    }

    .footerCol {
        width: 100%;
    }

    .footerCol h5 {
        margin-top: 5%;
    }

    .footerCol p {
        margin-top: 5%;
    }
}


@media screen and (min-device-width: 801px) 
and (max-device-width: 999px) {

        // - - GET STARTED BUTTON - - //

    .getStartedBtn {
        margin-bottom: 9.5%;
    }
    
    .getStartedBtn button {
        padding: 3%;
        width: 35%;
    }

        // - - AUDIENCE - - //

    .audienceList {
        margin-top: 7.5%;
    }

    .audienceList h1 {
        font-size: 21px;
        hyphens: auto;
        margin-bottom: 12%;
    }


        // - - DEMOS - - //

    .demo1Col1 {
        width: 90%;
        background-color: #8FC458;
    }

    .demo1Col2 {
        width: 100%;
        margin-top: 0px;
    }

    .demo1Col2 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

    .demo1Col2 img {
        margin-top: 0px;
    }

        // - - DEMO 2 - - //

    .demo2Col1 {
        width: 100%;
    }

    .demo2Col1 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

    .demo2Col2 {
        width: 90%;
        float: right;
        background-color: #8FC458;
    }

        // - - DEMO 3 - - //

    .demo3Col1 {
        width: 90%;
        margin-top: 12.5%;
        background-color: #8FC458;
    }

    .demo3Col2 {
        width: 100%;
    }

    .demo3Col2 p {
        font-size: 13.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

        // - - FOOTER- - //

    .footer {
        margin-top: 10%;
        height: 100%;
    }

    .footerCol {
        width: 100%;
    }

    .footerCol h5 {
        margin-top: 5%;
    }

    .footerCol p {
        margin-top: 5%;
    }

}

@media screen and (min-device-width: 1000px) 
and (max-device-width: 1439px) {

    // - - GET STARTED BUTTON - - //

    .getStartedBtn {
        margin-bottom: 9.5%;
    }
    
    .getStartedBtn button {
        padding: 3%;
        width: 35%;
    }

        // - - AUDIENCE - - //

    .audienceList {
        margin-top: 7.5%;
    }

    .audienceList h1 {
        font-size: 24px;
        hyphens: auto;
        margin-bottom: 12%;
    }


        // - - DEMOS - - //

    .demo1Col1 {
        width: 50%;
        background-color: #8FC458;
    }

    .demo1Col2 {
        width: 50%;
        margin-top: 0px;
    }

    .demo1Col2 p {
        font-size: 12.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

    .demo1Col2 img {
        margin-top: 0px;
    }

        // - - DEMO 2 - - //

    .demo2Col1 {
        width: 50%;
    }

    .demo2Col1 p {
        font-size: 12.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

    .demo2Col2 {
        width: 50%;
        float: right;
        background-color: #8FC458;
    }

        // - - DEMO 3 - - //

    .demo3Col1 {
        width: 50%;
        // margin-top: 12.5%;
        background-color: #8FC458;
    }

    .demo3Col2 {
        width: 50%;
    }

    .demo3Col2 p {
        font-size: 12.5px;
        margin-left: 7.5%;
        margin-right: 7.5%;
    }

}


`

export default class Landing extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    goToLogin = () => {
        window.location.href = "/login"
    }

    render () {

        let innerBullet = {
            textAlign: "justify"
        }

        let outerBullet = {
            textAlign: "justify"
        }


        return(
            <Styles>
                <Navbar expand="lg" className="theNavbar">
                    <Navbar.Brand className='logo' href="/">Salis</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="navLinks ms-auto">
                        <Nav.Link className="linkItem" href="/login" ><label><strong>Login</strong></label></Nav.Link>
                        {/* <Nav.Link className="linkItem" href="/sell" ><label>Home</label></Nav.Link> */}
                        {/* <Nav.Link className="linkItem" href="/donate" ><label>Donate</label></Nav.Link> */}
                        {/* <Nav.Link className="linkItem" href="/login" ><label>Login</label></Nav.Link> */}
                    </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <div className='header'>
                    <div className='brandInfo'>
                        <video autoPlay muted loop playsInline>
                            <source src="/assets/salisMainDemo.mp4" type="video/mp4"/>
                        </video>
                    </div>
                    <div className='brandInfo'>
                        <video autoPlay muted loop playsInline>
                            <source src="/assets/demoVid.mp4" type="video/mp4"/>
                        </video>
                        {/* <h1><u>How it Works:</u></h1>
                        <h5>Salis is a to-do list framework that helps you take small daily actions to help you foster personal growth and/or fight off slipping into depressive cycles.</h5>
                        <h5> We assume that you know more than we do, more specifically, we assume you have an idea of the general tasks you could do to gradually shift and improve various areas of your life.
                            We just help you organize those goals in a way that might make it easier for you to begin taking action.
                        </h5>
                        <h5>We focus on helping people in four main categories:</h5>
                        <div className='areas'>
                            <h4>Spiritual Wellness</h4>
                            <p>e.g. meditation / prayer</p>
                        </div>
                        <div className='areas'>
                            <h4>Physical Wellness</h4>
                            <p>e.g. exercise / sleep / healthy eating / hygiene</p>
                        </div>
                        <div className='areas'>
                            <h4>Mental Wellness</h4>
                            <p>e.g. journalling / doing bite-sized tasks</p>
                        </div>
                        <div className='areas'>
                            <h4>Relationships</h4>
                            <p>e.g. upkeep for your relationships</p>
                        </div> */}
                    </div>
                    <div className='getStartedBtn'>
                        <button
                        onClick={this.goToLogin}
                        >Get Started</button>
                        <p>(Beta version)</p>
                    </div>
                    <div className='audience'>
                        <h1>Is this to-do list for me?</h1>
                        <h2> it for sure is if -</h2>
                        <div className='audienceList'>
                            <div className='audienceLeft'><h1>⭐️</h1></div>
                            <div className='audienceRight'><h1>You come down on yourself very harshly for not getting tasks you need to do done</h1></div>
                            <div className='audienceLeft'><h1>⭐️</h1></div>
                            <div className='audienceRight'><h1>You very easily get overwhelmed by the things you have to get done on a given day</h1></div>
                            <div className='audienceLeft'><h1>⭐️</h1></div>
                            <div className='audienceRight'><h1>You tend to avoid to-do lists for reasons 1 & 2</h1></div>
                            <div className='audienceLeft'><h1>⭐️</h1></div>
                            <div className='audienceRight'><h1>You wish there was an alternative that could solve for reasons 1 to 3</h1></div>
                        </div>
                    </div>
                    <div className='demo1'>
                        <FadeInLeftDiv>
                        <div className='demo1Col1'>
                            <video autoPlay muted loop playsInline>
                                <source src="/assets/demo1Vid.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        </FadeInLeftDiv>
                        <div className='demo1Col2'>
                        <FadeInUpDiv>
                            <img src="assets/demo1Img.png"/>
                            {/* <div className='landingText'> */}
                                <h4>Users of Salis Say:</h4>
                                <p><i>"This feature has helped me not get overwhelmed by the long lists of things I typically have to do in a day.
                                    I can opt to not do a task I initially planned to do by moving it to the background - but I still know it's 
                                    something I need to do cause it's on my list. If I change my mind and decide I want to do the task, I can 
                                    always highlight the task again and bring my attention back it. This also works really well when I have a CRAZY
                                    amount of work to do on a given day - I literally grey every task except the one task I need to do at that moment
                                    and this helps me slowly work through my list of things to do."</i>
                                    <label>- a satisfied Salis user 😌</label>
                                    </p>
                            {/* </div> */}
                        </FadeInUpDiv>
                        </div>
                    </div>
                    <div className='demo2'>
                        <div className='demo2Col1'>
                        <FadeInUpDiv2>
                        <img src="assets/demo2Img.png"/>
                        {/* <div className='landingText'> */}
                            <h4>Users of Salis Say:</h4>
                            <p><i>"Sometimes I open my to-do list and honestly don't know where to start. I don't even have the energy to scroll down
                                and look at laundry list of tasks I need to do, let alone start doing them. Go-slow mode literally shortens my list to just one item at a time. 
                                I can shuffle through tasks until I land on a task that's a priority or a task I feel is manaegable for me to do at that time. This has 
                                made getting stuff on my to-do list done, a little bit easier."</i>
                                <label>- a happy Salis user 😊</label>
                            </p>
                        {/* </div> */}
                        </FadeInUpDiv2>
                        </div>
                        <FadeInRightDiv>
                        <div className='demo2Col2'>
                            <video autoPlay muted loop playsInline>
                                <source src="/assets/demo2Vid.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        </FadeInRightDiv>
                    </div>
                    <div className='demo3'>
                        <FadeInLeftDiv2>
                        <div className='demo3Col1'>
                            <video autoPlay muted loop playsInline>
                                <source src="/assets/demo3Vid.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        </FadeInLeftDiv2>
                        <div className='demo3Col2'>
                        <FadeInUpDiv3>
                        <img src="assets/demo3Img.png"/>
                            {/* <div className='landingText'> */}
                                <h4>Users of Salis Say:</h4>
                                <p><i>"It's nice to have a section that allows me to see the progress I've been able to make in a day in a fun way. Usually,
                                    I'm overwhelemed by tracking my progress for things I have to get done - because I always feel an immense
                                    anxiety that I won't meet my goal for a day, to the point that I don't even set goals sometimes. No matter what I get done,
                                    I feel a little more positive about it when I check my daily report. It's just a cute little reminder that I can
                                    be happy about doing even a few things - especially on days or weeks I don't feel particularly productive."</i>
                                    <label>- a giddy Salis user 😁</label>
                                </p>
                            {/* </div> */}
                        </FadeInUpDiv3>
                        </div>
                    </div>
                    <div className='demo2'>
                        <div className='demo2Col1'>
                        <FadeInUpDiv2>
                        <img src="assets/demo4Img.png"/>
                            <h4>Users of Salis Say:</h4>
                            <p><i>"I've been able to break up my long to-do lists into smaller chunks most effectively using the task trails. 
                                It helps me organize the immediate tasks I need to focus on at a given time (and sometimes also plan out an order of tasks for the day) and knock them out. It's 
                                also been a great way to work my way towards doing more challenging tasks. I start off with dead easy tasks and 
                                once I see I'm making progress I gain the momentum to carry me to do tougher tasks."</i>
                                <label>- a curious Salis user 🤔</label>
                            </p>
                        </FadeInUpDiv2>
                        </div>
                        <FadeInRightDiv>
                        <div className='demo2Col2'>
                            <video autoPlay muted loop playsInline>
                                <source src="/assets/demo4Vid.mp4" type="video/mp4"/>
                            </video>
                        </div>
                        </FadeInRightDiv>
                    </div>
                </div> 
                <div className='footer'>
                    <div className='footerCol'>
                        <img src="assets/salisLogoFooter.png"/>
                    </div>
                    <div className='footerCol'>
                        <h5
                        onClick={this.goToLogin}
                        >Login</h5>
                    </div>
                    <div className='footerCol'>
                        <p>Made with ❤️ & ☕️ in Nairobi © 2022</p>
                    </div>
                </div>
            </Styles>
        )
    }
}